import { render, staticRenderFns } from "./detailsAll.vue?vue&type=template&id=2e8419b9&scoped=true"
import script from "./detailsAll.vue?vue&type=script&lang=js"
export * from "./detailsAll.vue?vue&type=script&lang=js"
import style0 from "./detailsAll.vue?vue&type=style&index=0&id=2e8419b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8419b9",
  null
  
)

export default component.exports